import MenuItem from '@assets/theme/overrides/MenuItem';
import { Theme } from '@material-ui/core/styles';
import { merge } from 'lodash';

import Accordion from './Accordion';
import Alert from './Alert';
import Autocomplete from './Autocomplete';
import Avatar from './Avatar';
import Backdrop from './Backdrop';
import Badge from './Badge';
import Breadcrumbs from './Breadcrumbs';
import Button from './Button';
import ButtonGroup from './ButtonGroup';
import Card from './Card';
import Checkbox from './Checkbox';
import Chip from './Chip';
import Container from './Container';
import ControlLabel from './ControlLabel';
import Dialog from './Dialog';
import Drawer from './Drawer';
import Fab from './Fab';
import Grid from './Grid';
import IconButton from './IconButton';
import Input from './Input';
import InputLabel from './InputLabel';
import Lists from './Lists';
import LoadingButton from './LoadingButton';
import Menu from './Menu';
import Pagination from './Pagination';
import Paper from './Paper';
import Pickers from './Pickers';
import Popover from './Popover';
import Popper from './Popper';
import Progress from './Progress';
import Radio from './Radio';
import Rating from './Rating';
import Select from './Select';
import Skeleton from './Skeleton';
import Slider from './Slider';
import Snackbar from './Snackbar';
import Stepper from './Stepper';
import SvgIcon from './SvgIcon';
import Switch from './Switch';
import Table from './Table';
import Tabs from './Tabs';
import Timeline from './Timeline';
import ToggleButton from './ToggleButton';
import Tooltip from './Tooltip';
import TreeView from './TreeView';
import Typography from './Typography';

// ----------------------------------------------------------------------

export default function ComponentsOverrides(theme: Theme, containerId: string) {
  return merge(
    Fab(theme, containerId),
    Tabs(theme, containerId),
    Chip(theme, containerId),
    Card(theme, containerId),
    Menu(theme, containerId),
    MenuItem(theme, containerId),
    Grid(containerId),
    Input(theme, containerId),
    InputLabel(theme, containerId),
    Radio(theme, containerId),
    Badge(containerId),
    Lists(theme, containerId),
    Table(theme, containerId),
    Paper(containerId),
    Alert(theme, containerId),
    Switch(theme, containerId),
    Select(containerId),
    Button(theme, containerId),
    Rating(theme, containerId),
    Dialog(theme, containerId),
    Avatar(theme, containerId),
    Slider(theme, containerId),
    Drawer(theme, containerId),
    Pickers(theme, containerId),
    Stepper(theme, containerId),
    Tooltip(theme, containerId),
    Popover(theme, containerId),
    Popper(containerId),
    SvgIcon(theme, containerId),
    Checkbox(theme, containerId),
    Skeleton(theme, containerId),
    Timeline(theme, containerId),
    TreeView(theme, containerId),
    Backdrop(theme, containerId),
    Snackbar(containerId),
    Progress(theme),
    Container(containerId),
    Accordion(theme, containerId),
    IconButton(theme, containerId),
    Typography(theme, containerId),
    Pagination(theme, containerId),
    ButtonGroup(theme, containerId),
    Breadcrumbs(theme, containerId),
    Autocomplete(theme, containerId),
    ControlLabel(theme, containerId),
    ToggleButton(theme, containerId),
    LoadingButton(containerId)
  );
}
